/*
 * @Author: Teemo Ding
 * @Date: 2021-09-06 13:11:32
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 10:34:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/BasicInformation/index.tsx
 */
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import BasicComp from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/BasicInformation';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const BasicInformation = ({
  activeTime,
  setActiveTime,
  activeTimeError,
  setActiveTimeError,
  form,
  isPrimary,
  scTimezoneUTC,
  disableEdit,
  onCurrencyChange,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        containerClassName={`${css.sectionContainer} ${css.sectionContainerWeights}`}
        title={getI18n('general.basicInformation')}>
        <BasicComp
          activeTime={activeTime}
          setActiveTime={setActiveTime}
          form={form}
          activeTimeError={activeTimeError}
          setActiveTimeError={setActiveTimeError}
          isPrimary={isPrimary}
          scTimezoneUTC={scTimezoneUTC}
          disableEdit={disableEdit}
          onCurrencyChange={onCurrencyChange}
        />
      </SectionWrapper>
    </div>
  );
};

export default BasicInformation;
